module.exports = __webpack_public_path__ + "static/media/gas-networks.8e149f2a.png";